import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

// Report
export const getReportHeader = async (reportName) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.REPORT}/v1/report/header`,
            {
                params: {
                    reportName,
                },
            },
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const getReportHeaderById = async (reportId) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.REPORT}/v1/report/header/by/id`,
            {
                params: {
                    reportId,
                },
            },
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const generateReport = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.REPORT}/v1/report/generate`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const generateMISReport = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.REPORT}/v1/report/mis/generate`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const generateRevenueReport = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.REPORT}/v1/revenue/distribution/report/generate`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const generatePerformanceFinanceReport = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.REPORT}/v1/performance/finance/report/generate`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const downloadJobSummaryExcel = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.REPORT}/v1/report/downloadJobSummaryExcel`,
            data,
            {
                responseType: "blob",
            }
        );
        return response.data;
    } catch (e) {
        console.error(e);
        throw e;
    }
};
